var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTexture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3546 9.57024L21.4815 10.6971C21.9569 11.1721 22.2347 11.8096 22.259 12.4812C22.2833 13.1529 22.0522 13.8087 21.6122 14.3168L21.4825 14.455L14.717 21.2214C14.2419 21.6967 13.6043 21.9744 12.9326 21.9984C12.261 22.0225 11.6052 21.7912 11.0972 21.3511L10.959 21.2214L9.83107 20.0946L20.3546 9.57024ZM1.56235 1.3017C2.50319 0.359828 3.69917 -0.112174 4.94723 0.0228356C6.18148 0.155719 7.31261 0.865847 8.19604 1.98526C9.14006 3.18333 10.0033 4.88955 10.6794 6.4225C11.01 7.17089 11.9126 7.35162 12.4612 6.92745L12.56 6.84134L13.2138 6.18756C13.689 5.71227 14.3266 5.43465 14.9982 5.41059C15.6699 5.38652 16.3257 5.6178 16.8336 6.05786L16.9718 6.18756L18.8514 8.06706L8.3268 18.5904L6.44832 16.7109C5.97302 16.2357 5.69539 15.5981 5.67133 14.9265C5.64726 14.2549 5.87855 13.5991 6.31862 13.0911L6.44832 12.9529L7.10212 12.2991C7.63366 11.7676 7.47845 10.7694 6.68326 10.4186C5.15028 9.74245 3.44402 8.87924 2.24592 7.93524C1.12649 7.05183 0.417406 5.92073 0.283456 4.68651C0.148444 3.43847 0.620456 2.24146 1.56235 1.3017Z",
    fill: "#1D5D9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexture);
export default __webpack_public_path__ + "static/media/texture.678a43073dbf7b017d05d4e2827112d1.svg";
export { ForwardRef as ReactComponent };